export enum RequirementClassEnum {
	OPTIONAL = 'Desejável',
	MANDATORY = 'Obrigatório',
}
